import '@wp/ui/styles.css';
import './styles.css';
import { startApp } from './app';

void startApp(document.getElementById('app') as HTMLElement);
